import { FormArray, FormControl, FormGroup, ValidationErrors, AsyncValidatorFn, AbstractControl } from '@angular/forms';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter'; 
import { SiriusDataService } from '@ibtech/sirius-angular-service';
import { MailAddressValidationModel, PhoneNumberValidationModel, SharedModel } from '../models/shared.model';
import { ValidationService } from '../service/validation-service';

export class CustomValidators {
    static dataService: SiriusDataService;
    static minLimit: number = 0;
    static maxLimit: number = 0;
    constructor(validationService: ValidationService, dataService: SiriusDataService) {
    }


    static validateMail(control: AbstractControl) {
        var emailModel = new MailAddressValidationModel();
        emailModel.MailAddress = control.value;
      return new Promise((resolve) => {
        this.dataService.post<MailAddressValidationModel>("ValidateEmail", emailModel).toPromise().then(r => {
                if (r.IsValid) {
                    resolve(null);
                } else {
                    resolve({ 'mailNotValid': true });
                }
            })
        });
    }

    static validatePhoneNumber(control: AbstractControl) {
        var phoneModel = new PhoneNumberValidationModel();
        phoneModel.PhoneNumber = control.value;
      return new Promise((resolve) => {
        this.dataService.post<PhoneNumberValidationModel>("ValidatePhonenumber", phoneModel).toPromise().then(r => {
                if (r.IsValid) {
                    resolve(null);
                } else {
                    resolve({ 'phoneNotValid': true });
                }
            })
        });
    }

    static isDropdownEmpty(control: AbstractControl): { [key: string]: boolean } | null {

        const isEmpty = control && control.value && (control.value.Value == SharedModel.DefaultChooseValue);

        if (isEmpty) {
            return { required: true };
        }
        return null;
    }

    static isMinMaxLimit(control: AbstractControl): { [key: string]: boolean } | null {

        const isEmpty = control && control.value && (control.value.Value == SharedModel.DefaultChooseValue);
        if (control == undefined || control.value == undefined) {
            return null;
        }
        var n = +control.value;

        if (isEmpty) {
            return { required: true };
        }
        if (CustomValidators.maxLimit != 0 && (n > CustomValidators.maxLimit || n < CustomValidators.minLimit)) {
            return { minmaxlimit: true }
        }
        return null;
    }


    static isTextBoxEmpty(control: AbstractControl): { [key: string]: boolean } | null {

        var isEmpty = control && control.value;

        if (isEmpty == null || isEmpty == "") {
            return { required: true };
        }

        if (typeof control.value === "string" && control.value.trim() == "") {
            return { required: true };
        }

        return null;
    }

    static isLowerThanZero(control: AbstractControl): { [key: string]: boolean } | null {

        const val = control.value;

        if (val < 0) {
            return { lowerThanZero: true };
        }
        return null;
    }

    static isTelephoneNumber(control: AbstractControl): { [key: string]: boolean } | null {

        const isValidPhoneNumber = /^\(\d{3}\)\s{1}\d{3}-\d{2}-\d{2}$/.test(control.value);

        if (!isValidPhoneNumber) {
            return { telephoneNumber: true };
        }
        return null;
    } 

    static isDate(control: AbstractControl): { [key: string]: boolean } | null {
        //const isValidDate = /^\d{2}\/\d{2}\/\d{4}$/.test(control.value);
        const isValidDate = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/((19|2[0-9])[0-9]{2})$/.test(control.value);

        if (control != undefined && control.value != undefined) {
            if (control.value == "" || control.value.indexOf('_') > -1) {
                return { required: true };
            }
            if (!isValidDate) {
                return { date: true };
            }
        }
        return null;
    }

    static isGreaterThanToday(control: AbstractControl): { [key: string]: boolean } | null {
        if (control.value) {
            var from = control.value.split("/");
            var date = new Date(from[2], from[1] - 1, from[0]);
            var today = new Date();
            if (date > today) {
                return { greater: true };
            }
        }
        return null;
    }

    static isTckn(control: AbstractControl): { [key: string]: boolean } | null {

        const value: string = control.value;

        if (value == null || value == undefined)
            return null;
        else if (value.length == 11) {
            var isEleven = /^[0-9]{11}$/.test(value);
            var totalX = 0;
            for (var i = 0; i < 10; i++) {
                totalX += Number(value.substr(i, 1));
            }
            var isRuleX = totalX % 10 == +value.substr(10, 1);
            var totalY1 = 0;
            var totalY2 = 0;
            for (var i = 0; i < 10; i += 2) {
                totalY1 += Number(value.substr(i, 1));
            }
            for (var i = 1; i < 10; i += 2) {
                totalY2 += Number(value.substr(i, 1));
            }
            var isRuleY = ((totalY1 * 7) - totalY2) % 10 == +value.substr(9, 0);

            if (!(isEleven && isRuleX && isRuleY)) {
                return { tckn: true };
            } else {
                return null;
            }
        }

        return { tckn: true };

    }  

}
